import { useState } from "react";

import API from "Signups/API.js";
import { getSignedUpViaID } from "Signups/SharedComponents/getSignedUpViaID";
import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { useSignups } from "Signups/state";

const useCancelSignupItem = ({ signupItemID, closeItem }) => {
  const [state, dispatch] = useSignups();
  const [isLoading, setIsLoading] = useState(false);
  const signedUpViaID = getSignedUpViaID();

  const cancelSignup = () => {
    if (isLoading) return;
    setIsLoading(true);

    if (state.user.canSignupHouseholdMembers) {
      cancelHouseholdSignup();
    } else {
      cancelNonHouseholdSignup();
    }
  };

  const cancelHouseholdSignup = () => {
    API.cancelAllHouseholdUserSignups({
      signupListID: state.currentSignupList.ID,
      signupItemID,
      signedUpViaID,
      householdID: state.user.householdID,
    })
      .post()
      .then((resp) => {
        dispatch({
          type: "Item Signup Updated",
          userSignupItems: resp.userSignupItems,
          newCounts: resp.itemSlotsTaken,
          cancelled: true,
          paymentAmountNeeded: 0,
        });
        dispatch({ type: "updateTriggerRespondentRefresh", payload: true });
        dispatch({
          type: "updateSlotsTaken",
          payload: { signupItemID, slotsTaken: resp.itemSlotsTaken },
        });
        setIsLoading(false);

        closeItem();
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err.error));
        setIsLoading(false);
        closeItem();
      });
  };

  const cancelNonHouseholdSignup = () => {
    const signedUpViaID = getSignedUpViaID();
    const emailOrPhone = state.user.emailOrPhone || null;

    API.cancelSignupForItem2({ signupItemID, signedUpViaID, emailOrPhone })
      .post()
      .then((resp) => {
        dispatch({
          type: "Item Signup Updated",
          userSignupItems: resp.userSignupItems,
          newCounts: resp.itemSlotsTaken,
          cancelled: true,
          paymentAmountNeeded: 0,
        });
        dispatch({
          type: "updateSlotsTaken",
          payload: { signupItemID, slotsTaken: resp.itemSlotsTaken },
        });
        dispatch({ type: "updateTriggerRespondentRefresh", payload: true });
        setIsLoading(false);
        closeItem();
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err.error));
        setIsLoading(false);
        closeItem();
      });
  };

  return [isLoading, cancelSignup];
};

export { useCancelSignupItem };
